/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { GtmManager } from '../../utils/GtmManager';
import { StorageHelper } from '../../utils/StorageHelper';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
  setShowMiCuenta: (showCuenta: boolean) => void;
}

const MainmenuLink: FC<Props> = ({
  text,
  url,
  className,
  openInNewWindow,
  setShowMiCuenta,
}) => {
  const clickLink = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    GtmManager.sendMenuLinkClickGTM(text);
    if (openInNewWindow) {
      window.open(url);
    } else if (url) {
      StorageHelper.setUrlInterna();
      window.location.href = url;
    }
  };
  const clickLinkAndHideMiCuenta = () => {
    GtmManager.sendMenuLinkClickGTM(text);
    setShowMiCuenta(false);
  };
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
      <li
        className={`main-menu__item ${className}`}
        onClick={(e) => {
          clickLink(e);
          clickLinkAndHideMiCuenta();
        }}
      >
        {(() => {
          if (url?.slice(0, 4) !== 'http') {
            return (
              <Link
                // to={url || '/'}
                to={(location) => {
                  const l = location;
                  l.search = '';
                  return { ...l, pathname: url || '/' };
                }}
                target={openInNewWindow ? '_blank' : ''}
                onClick={() => clickLinkAndHideMiCuenta()}
              >
                {text}
              </Link>
            );
          }
          return (
            <a
              href="javascript:void(0)"
              onClick={(e) => clickLink(e)}
              target={openInNewWindow ? '_blank' : ''}
              rel="noopener noreferrer"
            >
              <span className="tt">{text}</span>
            </a>
          );
        })()}
      </li>
    </>
  );
};

export default MainmenuLink;
